import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./components/shared/header";
import Notification from "./components/shared/notification";
import Spinner from "./components/shared/spinner";
import SideNav from "./components/shared/sidenav";
import { AppRoutes } from "./navigation/app-routes";
import { getCookie } from "./utils/cookie-service";
import { withRouter } from "./utils/withRouter";
import { updateCompany } from "./store/global/actions";
import { AuthRoutes } from "./navigation/auth-routes";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./components/shared/Footer";

function App() {
  const token = getCookie("token");
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth);
  const companyId = useSelector((state) => state.global.companyId);
  const activeSidebar = useSelector((state) => state.global.activeSideBar);
  const location = useLocation(); // Use useLocation to get the current URL

  // if you want this feature which is if token has expire then redirect login page then  onboarding routes will not work  in this case
  useEffect(() => {
    if (!token && location.pathname !== "/onboarding/employee-details/add") {
      navigation("/");
    }
  }, []);

  useEffect(() => {
    const companyId = getCookie("hrms-companyId");
    if (companyId) {
      dispatch(updateCompany(companyId));
    }
  }, []);

  return (
    <div className="my-container">
      <Notification />
      <Spinner />
      {authUser.isAuthenticated ? (
        <div className="wrapper">
          {companyId !== null || authUser.currentUser !== "Admin" ? (
            <>
              <input
                type="checkbox"
                id="toggle-menu-desktop"
                className="toggle-menu-desktop"
                hidden
              />
              <input
                type="checkbox"
                id="toggle-menu-mobile"
                className="toggle-menu-mobile"
                hidden
              />
              <label htmlFor="toggle-menu-mobile" className="sidebar-overlay" />
              <Header />
              <SideNav />
              <div className={`page-wrapper`}>
                <AppRoutes />
              </div>
              <Footer />
            </>
          ) : (
            <>
              <AppRoutes />
            </>
          )}
        </div>
      ) : (
        <div className="wrapper">
          <AuthRoutes />
        </div>
      )}
    </div>
  );
}
export default withRouter(App);
